<style scoped>
  .app-base-layout {
    padding: 84px 0 60px 0;
  }
</style>

<template>
  <div class="app-base-layout">
    <Row type="flex">
      <Col :xs="xs" :sm="sm" :md="md" :lg="lg">
        <slot></slot>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: 'AppLayout',
    props: {
      xs: { type: Number, default: 24 },
      sm: { type: Number, default: 24 },
      md: { type: Number, default: 24 },
      lg: { type: Number, default: 24 },
    }
  }
</script>
